import React, { useEffect, useMemo } from "react";
import EnvironmentConfigVariableList from "../components/EnvironmentConfigVariableList";
import API from "../api";
import { useResource } from "../useResource";
import { Environment } from "../_generated";
import analytics from "../analytics";

export default function EnvironmentConfigPage({
  projectName,
  environment,
}: {
  projectName: string;
  environment: Environment;
}) {
  const [services] = useResource(API.services.list, projectName);
  const [configVariables] = useResource(
    API.environmentConfigVars.list,
    String(environment.pk),
    projectName
  );

  const serviceNames = useMemo(() => {
    const serviceNames = new Map<number, any>();
    for (const service of services) {
      if (service.pk) serviceNames.set(service.pk, service.name);
    }
    return serviceNames;
  }, [services]);

  useEffect(() => {
    analytics.page("EnvironmentConfig");
  }, []);

  return (
    <EnvironmentConfigVariableList
      configVariables={configVariables}
      serviceNames={serviceNames}
      onVariableCreate={async (configVar) =>
        await API.environmentConfigVars.create(
          String(environment.pk),
          projectName,
          configVar
        )
      }
      onVariableUpdate={async (configVar) =>
        await API.environmentConfigVars.update(
          String(environment.pk),
          String(configVar.pk),
          projectName,
          configVar
        )
      }
      onVariableDelete={async (configVarID) =>
        await API.environmentConfigVars.delete(
          String(environment.pk),
          String(configVarID),
          projectName
        )
      }
    />
  );
}
